
<template>
  <v-app id="searchIpfcExact">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Sales partner Invoices</v-card-title>
      <v-simple-table dense>
        <thead>
           <tr>
             <th>To exact</th>
             <th>Number</th>
             <th>Description</th>
             <th>Date / Time</th>
             <th>Partner</th>
             <th>Country</th>
             <th>User</th>
           </tr>  
         </thead>
         <tbody>
         <tr>
          <td><v-checkbox v-model="allSelected" dense></v-checkbox></td>
          <td>Select all</td> 
         </tr>   
         </tbody> 
         <tbody v-for="(ipfcRecord,i) in searchIpfcExact" :key="i">
           <tr>
             <td><v-checkbox v-model="ipfcRecord.ipfc_toexact" dense @click="checkBoxes()"></v-checkbox></td>
             <td @click="$router.open('/task/inpt/ipfc/onIpfc/' + ipfcRecord.ipfc_encrid)">{{ipfcRecord.ipfc_nr}}</td>
             <td @click="$router.open('/task/inpt/ipfc/onIpfc/' + ipfcRecord.ipfc_encrid)">{{ipfcRecord.ipfc_oms}}</td>             
             <td @click="$router.open('/task/inpt/ipfc/onIpfc/' + ipfcRecord.ipfc_encrid)">{{ipfcRecord.ipfc_dt}}</td>
             <td @click="$router.open('/task/inpt/ipfc/onIpfc/' + ipfcRecord.ipfc_encrid)">{{ipfcRecord.inpt_naam}}</td>
             <td>{{ipfcRecord.land_code}}</td>
             <td>{{ipfcRecord.gebr_code}}</td>
           </tr>  
         </tbody>
            
       </v-simple-table>
       <v-btn class="primary ma-2" :disabled="!oneChecked" small @click="ipfcToExact()">To exact</v-btn>
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      oneChecked: false,
      searchIpfcExact: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/searchIpfcExact.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchIpfcExact"
          },
          searchIpfcExact: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchIpfcExact = res.data.searchIpfcExact;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    checkBoxes() {
      this.oneChecked = false;
      for(let i = 0;i < this.searchIpfcExact.length; i++ ) {
        if (this.searchIpfcExact[i].ipfc_toexact == true) this.oneChecked = true;
      }  
      return 0;
    },
    ipfcToExact() {
     
        this.$axios
          .post("ares/json/ares/task/inpt/ipfc/ipfcToExact.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "ipfcToExact",
            },
            ipfcToExact: {
              searchIpfcExact: this.searchIpfcExact
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.items = res.data.ipfcToExact;
              window.open(this.items.filename,'_blank');
              this.$router.reload('/task/inpt/ipfc/searchIpfcExact/'); 
              /*
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.ipfcToExact.text,
                color: res.data.ipfcToExact.color,
              });
              */
            }
          });
      
    }
  },
  computed: {
    allSelected: {
      set(selected) {
        this.searchIpfcExact.forEach(function (user) {
          user.ipfc_toexact = selected;
        });
        this.oneChecked = false;
        for(let i = 0;i < this.searchIpfcExact.length; i++ ) {
          if (this.searchIpfcExact[i].ipfc_toexact == true) this.oneChecked = true;
        } 
      },
      get() {
        return this.searchIpfcExact.every(function(user) {
          return user.ipfc_toexact;
        });  
      }
    }
  }
};

</script> 
